import { gql } from '@grandvisionhq/graphql';

const commercialCategoryFragment = gql`
  fragment CommercialCategoryFragment on CommercialCategory {
    ancestors {
      key
      name
    }
    key
    name
  }
`;
const mediaFragment = gql`
  fragment mediaFragment on Media {
    images {
      url
      dimensions {
        w
        h
      }
      label
    }
  }
`;
const frameFeaturesFragment = gql`
  fragment frameFeaturesFragment on FrameFeatures {
    bridgeWidth
    color
    colorAllLocales {
      locale
      value
    }
    material
    materialAllLocales {
      locale
      value
    }
    templeLength
    type
    typeAllLocales {
      locale
      value
    }
    width
    shape {
      displayName
      displayNameAllLocales {
        locale
        value
      }
      shape
    }
    size {
      displayName
      size
    }
    templeType
  }
`;
const lensFeaturesFragment = gql`
  fragment lensFeaturesFragment on LensFeatures {
    isPolarized
    isGlazeble
    uvRaysProtection
    lensWidth
    lensHeight
    lensColor
  }
`;

export { commercialCategoryFragment, frameFeaturesFragment, lensFeaturesFragment, mediaFragment };
//# sourceMappingURL=small-fragments.js.map
